import React from "react";
import UserForm from './UserForm';

const CreateNewUser = ({ onCloseDialog }) => <UserForm onCloseDialog={onCloseDialog} />;

export default CreateNewUser;
